export default __webpack_public_path__ + "static/media/logo.90509f51.png";